import { HS_WEB_BASE_URL } from './src/environments/environment';

export const USER_MANAGEMENT = HS_WEB_BASE_URL + '/user/v1';
export const USER_VERIFICATION = HS_WEB_BASE_URL + '/auth/v1';
export const AUTHENTICATION = HS_WEB_BASE_URL + '/auth/v1';
export const PROPERTY_MANAGEMENT = HS_WEB_BASE_URL + '/prop/v1';
export const PRODUCT_MANAGEMENT = HS_WEB_BASE_URL + '/prod/v1';
export const ASSESSMENT_MANAGEMENT = HS_WEB_BASE_URL + '/assm/v1';
export const Questionnaires = HS_WEB_BASE_URL + '/ques/v1';
export const ASSESSMENT_RESULT = HS_WEB_BASE_URL + '/rules/v1';
export const VIEWRESULT = HS_WEB_BASE_URL + '/rules/v1';
export const CATEGORY_MANAGEMENT = HS_WEB_BASE_URL + '/prod/v1';
export const PROD_M = HS_WEB_BASE_URL + '/prod/v1';

// Validation Patttern
export const EMAIL_PAT = '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}';
export const NAME_PAT_WITH_SPACES = '^[a-zA-Z][a-zA-Z0-9-_\. ]{1,50}$';
export const NAME_PAT_NO_SPACES = '[a-zA-Z]{1,50}$';
export const USERNAME = '^[a-zA-Z]{1,50}$';
export const DATE_PAT = '(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d ';
export const PRICE_PAT = '^[0-9]+$';
export const PASSWORD_PAT = '^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).*$';
export const INPUTNUMBER = '^\d{1,9}$|^\d{1,10}$';
export const PASSWORD_MIN_LEN = 8;

// Validation required error messages
export const EMAIL_ERR_REQ = 'Enter an email.';
export const FIRST_NAME_ERR_REQ = 'Enter first name.';
export const LAST_NAME_ERR_REQ = 'Enter last name.';
export const DOB_ERR_REQ = 'Enter date of birth.';
export const USER_ERR_REQ = 'Enter username.';
export const PASSWORD_ERR_REQ = 'Enter a password.';
export const PASSWORD_MIN_LEN_MSG = 'Use 8 characters or more for your password.';
export const CONFIRM_PASS_ERR_REQ = 'Confirm your password.';
export const VERIFYCODE_ERR_REQ = 'Enter OTP.';
export const COMPANY_ERR_REQ = 'Enter company name.';
export const JOBTITLE_ERR_REQ = 'Enter job title.';
export const INCOME_ERR_REQ = 'Enter income.';
export const TYPE_ERR_REQ = 'Select property type.';
export const ADDRESS1_ERR_REQ = 'Enter address.';
export const PRICE_ERR_REQ = 'Enter property price.';
export const USER_EMAIL_ERR_REQ = 'Enter username or email id.';
export const VERIFY_ERR_REQ = 'Enter verification code.';
export const OTP_ERR_REQ = 'Enter otp code.';
export const CURR_PASS_ERR_REQ = 'Enter current password.';
export const NEW_PASS_ERR_REQ = 'Enter new password.';

// Validation pattern error messages
export const EMAIL_ERR_PAT = 'Invalid email.';
export const USER_ERR_PAT = 'Invalid username.';
export const CONFIRM_PASS_ERR_MATCH = 'This password does not match with the one above.';
export const INCOME_ERR_PAT = 'Only numeric values are allowed in income.';
export const PRICE_ERR_PAT = 'Only numeric values are allowed in property price.';

export const CONTENT_TYPE = 'Content-Type';
export const TOKEN = 'X-Amz-Security-Token';
export const PROVIDER = 'Authorization';

export const ORDER_BY = 'location';
export const ORDER_BY_NAME = 'name';

export const ORDER = 'desc';
export const COMPARISON = 'AND';
export const MATCH_TYPE = 'begin';
export const PRODUCTLIMIT = 200;
export const FEATURELIMIT = 100;

export const ASSESSMENT_TYPE = 'smart';

export const EMPTY_VALUE = 'N/A';

export const ASSMT_TITLE = {
    'smart': 'Smart',
    'wellness': 'Wellness and Health Safety',
    'green': 'Green',
    'physical security': 'Physical Security'
};

export const SUBTYPE_QUESTION_ = {
    'smart': 'What rooms / features do you have in your home?',
    'wellness': 'What areas of wellness, health and protection are you concerned about?',
    'green': 'Completing each area enables better results for you.',
    'physical security': 'What security features do you have?'
};

export const QUESTION_ = {
    'smart': {
        'default': 'Which categories do you have or are relevant to you?'
    },
    'wellness': {
        'default': 'Please provide information for:',
        'health_diagnostics': 'Select items for monitoring your personal health.',
        'personal_protection': 'Select items for protecting you and others.',
        'wellness_and_exercise': 'Select items for improving wellness and health.'
    },
    'green': {
        'default': 'Please provide information for:',
        'water': 'Tell us about your water usage at home. Please select which applies to you.',
        'about_you': 'Please tell us a bit more about your energy consuming habits'
    },
    'physical security': {
        'default': 'Which appliances do you have?',
        'outside_security': 'Which areas apply to you?',
        'monitoring_and/or_sensors': 'What categories are relevant to you?'
    }

};

export const SMART_CATEGORIES_ID = [
    {id: 'bath', itemName: '67aa8c97-b865-4e45-8d70-4b93a8363b00'},
    {id: 'air conditioner', itemName: 'e05eee9c-089a-44cf-aed7-4097b53f916d'},
    {id: 'cooktop', itemName: '71931dfc-7074-4537-bd2c-6221a5c5b331'},
    {id: 'cooktop-oven', itemName: 'cd144f8a-eb4f-4d9a-8bfd-bb903448b8b1'},
    {id: 'dryer', itemName: '9111ec62-bf7e-4b59-a69f-7f782976245a'},
    {id: 'freezer', itemName: '951ebfcb-e87d-45e0-aa9d-3324762e1751'},
    {id: 'hot tub', itemName: '57a798ff-5a41-4b68-aa96-152f2c49df8c'},
    {id: 'microwave', itemName: '6bd511b7-c825-4812-9c0c-b3cf32d2d796'},
    {id: 'oven', itemName: '27e906f1-4cfb-4575-b6f2-de3341c4f913'},
    {id: 'refrigerator', itemName: 'b570a5cb-3729-4e36-90a2-89da5a9dcd6f'},
    // { id:  'Sauna', itemName : 'fed1b52c-171b-4abc-95bc-3f55411f4999' },
    {id: 'shower', itemName: '314d39d5-e9bf-4969-96d3-2ad18658cc82'},
    {id: 'toilet', itemName: '4e2f7036-f5ed-44da-966d-14577d60b94c'},
    {id: 'washing machine', itemName: '8af82e02-8cf4-4766-b08b-8918b8ebbedd'}
];





